module.exports = __webpack_public_path__ + "img/next_move_intro.9aad7ca6.png";